import { WuiThemeSection } from '@jwplayer/wui-react';
import { Suspense, lazy } from 'react';

import { useCurrentRoute } from '../../../module/routing/hooks';
import { ContainerPage } from '../../container/page';

import { MainNav } from './main-nav';
import css from './style.module.scss';
import { TopNav } from './top-nav';
import { UploadModal } from './upload-modal';

const AdBlockerWarning = lazy(() => import('/component/ad-blocker-warning'));

export function ChromeMain({ children }: { children?: React.ReactNode }) {
  const currentRoute = useCurrentRoute();
  const hideTopNav = currentRoute?.uiOptions?.topNav?.hideTopNav;

  return (
    <>
      <div className={css.chrome}>
        <MainNav />

        <div className={css.main}>
          {!hideTopNav && <TopNav />}

          <WuiThemeSection
            themed={['fg']}
            theme={currentRoute?.uiOptions?.pageTheme}
            className={css.mainContent}
            data-color-bg={currentRoute?.uiOptions?.pageBackgroundColor ?? 'default'}
          >
            <ContainerPage>
              {children}
              <Suspense fallback={null}>
                <AdBlockerWarning />
              </Suspense>
            </ContainerPage>
          </WuiThemeSection>
        </div>
      </div>

      <UploadModal uploadType="media" />
    </>
  );
}
